import { tnsService } from '../services/tns-service';

export const uspsService = {
    commonUspsSlider: () => {
        const uspsSliderContainer = document.querySelector('.usps-slider');
        const footerUspBar = document.querySelector('.js_footer-uspbar');
        const pageUspBar = document.querySelector('.page-uspbar');
    
        if (uspsSliderContainer) {
            tnsService.initTns({
                container: '.usps-slider .slides',
                onInit: () => $(uspsSliderContainer).removeClass('invisible')
            });
        }
    
        if (pageUspBar) {
            tnsService.initTns({
                container: '.page-uspbar .slides',
                onInit: () => $(pageUspBar).removeClass('invisible'),
            });
        }
    
        if (footerUspBar) {
            tnsService.initTns({
                container: '.js_footer-uspbar .slides',
                onInit: () => $(footerUspBar).removeClass('invisible'),
            });
        }
    },

    setUspText: () => {
        $('.usps-header').each(function(item, element) {
            $(element).html(window.stockMessages.stockDisplayMessageInHeader);
        });
    
        $('.usps-footer').each(function(item, element) {
            $(element).html(window.stockMessages.stockDisplayMessageInFooter);
        });
    },
}